import React, { useContext } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import List from "./List";
import SigninSheetEntry from "./Visitor";
import { SigninSheetProvider } from "./SigninSheetContext";
import AppContext from "AppContext";

function SigninSheet(props) {
    const {
        api: {
            Management: { SigninSheet },
        },
    } = useContext(AppContext);
    return (
        <SigninSheetProvider value={SigninSheet}>
            <Switch>
                <Route exact path="/check-in" component={List} />
                <Route exact path="/check-in/add" render={(props) => <SigninSheetEntry {...props} mode="add" title="" />} />
                <Route exact path="/check-in/:id" render={(props) => <SigninSheetEntry {...props} mode="detail" title="" />} />
                <Route exact path="/check-in/:id/update" render={(props) => <SigninSheetEntry {...props} mode="update" title="" />} />
            </Switch>
        </SigninSheetProvider>
    );
}

export default withRouter(SigninSheet);
